import { ContextService } from '../../../../services/context_service';
import { DataService } from '../../../../services/data_service';
import { getEigenstromTypen } from '../../../../helpers/getEigenstromTypen';
import { IDs } from '../../../../helpers/IDs';
import { lazyInject } from '../../../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../../../helpers/RoutingIDs';
import { StandorteBiomasse } from './StandorteBiomasse';
import { StandorteKwk } from './StandorteKwk';
import { StandortePhotovoltaik } from './StandortePhotovoltaik';
import { StandorteSolarthermie } from './StandorteSolarthermie';
import { StandorteWaermepumpen } from './StandorteWaermepumpen';
import { StandorteWindkraft } from './StandorteWindkraft';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../../../css/tabs.css';
import { TriggerService } from '../../../../core/trigger/trigger_service';
import { WSpinner } from '../../../../core/elements/spinner/WSpinner';
import { i18n } from '../../../../i18n/i18n';
import style from './StandortEigenstromTabs.less';

interface StandorteEigenstromTabsProps extends React.ClassAttributes<any> {
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
    typeFilter?: string;
    data: any;
    onTypenChange?: (typen: any[]) => void;
}

interface StandorteEigenstromTabsState {
    eigenstromAuswahl: any[];
    eigenstromTypen: any[];
    tabIndex: number;
    loading: boolean;
}

export class StandorteEigenstromTabs extends React.Component<StandorteEigenstromTabsProps, StandorteEigenstromTabsState> {

    constructor(props: any) {
        super(props);
        this.state = {
            eigenstromAuswahl: undefined,
            eigenstromTypen: undefined,
            tabIndex: this.contextService.get('tabIdxStandorteEigenstromTabs') || 0,
            loading: false
        };
        this.handleAuswahl = this.handleAuswahl.bind(this);
    }

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.loadData();
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
        if ((this.props.standortSelected || {}).tid !== (prevProps.standortSelected || {}).tid) {
            this.setState({ eigenstromAuswahl: undefined, eigenstromTypen: undefined }, this.loadData);
        }
    }

    loadData() {
        this.dataService.loadData(IDs.ENT_ANLAGEN_EIGENSTROM, { standort_tid: this.props.standortSelected.tid }, { resolve: false, bundle: false }, (res: any) => {
            this.setState({ eigenstromAuswahl: res[IDs.ENT_ANLAGEN_EIGENSTROM], eigenstromTypen: getEigenstromTypen(this.props.data) || [] });
        }, IDs.MOD_ETOOL);
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_STANDORTE_ERNEUERBARE_ENERGIEN;
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void) {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_STANDORTE_ERNEUERBARE_ENERGIEN;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxStandorteEigenstromTabs', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    handleAuswahl(typ_tid: number, checked: boolean): void {
        if (this.state.loading) {
            return;
        }
        let arr = this.state.eigenstromAuswahl;
        const found = arr.find((aw: any) => aw.anlagen_eigenstrom_typ_tid === typ_tid);
        const doneFunc = () => {
            this.triggerService.fire('reload', IDs.ENT_ANLAGEN_EIGENSTROM, (data: any) => {
                // console.log(data, arr);
                this.setState({ loading: false });
                if (this.props.onTypenChange) {
                    this.props.onTypenChange(arr);
                }
            });
        };
        if (found && !checked) {
            arr = arr.filter((aw: any) => aw.anlagen_eigenstrom_typ_tid !== typ_tid);
            this.setState({ loading: true }, () => {
                this.dataService.delData(IDs.ENT_ANLAGEN_EIGENSTROM, IDs.MOD_ETOOL, { tid: found.tid }, {}, () => {
                    this.setState({ eigenstromAuswahl: arr }, doneFunc);
                });
            });
        }
        if (!found && checked) {
            const newItem = { tid: 0, standort_tid: +this.props.standortSelected.tid, anlagen_eigenstrom_typ_tid: +typ_tid };
            arr.push(newItem);
            this.setState({ loading: true }, () => {
                this.dataService.setData(IDs.MOD_ETOOL, IDs.ENT_ANLAGEN_EIGENSTROM, newItem, (iid: number) => {
                    if (iid > 0) {
                        const idx = arr.findIndex((r: any) => r.tid === 0);
                        if (idx >= 0) {
                            arr[idx].tid = iid;
                        }
                    }
                    this.setState({ eigenstromAuswahl: arr }, doneFunc);
                });
            });
        }
    }

    render(): JSX.Element {
        const eigenstromTypen: any[] = getEigenstromTypen(this.props.data) || [];
        const tabRoutings: Array<any> = ['Auswahl', ...eigenstromTypen].map((s: any, idx: number) => {
            return {
                path: {
                    ...RoutingIDs.ROUTE_DATENEINGABE_ERNEUERBARE_ENERGIEN,
                    [RoutingIDs.TABS_DATENEINGABE_ERNEUERBARE_ENERGIEN]:
                        this.props.routing && this.props.routing.path ? this.props.routing.path[RoutingIDs.TABS_DATENEINGABE_ERNEUERBARE_ENERGIEN] || 0 : 0,
                    [RoutingIDs.TABS_STANDORTE_ERNEUERBARE_ENERGIEN]: idx,
                    terminateOn: RoutingIDs.TABS_STANDORTE_ERNEUERBARE_ENERGIEN
                }
            };
        });

        return (
            <div
                style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}
            >
                <Tabs
                    className='tabs-dateneingabe'
                    style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                    selectedIndex={this.state.tabIndex}
                    // onSelect={
                    //     (tabIndex, lastIndex, event) => this.setState(
                    //         { tabIndex },
                    //         () => this.contextService.set('tabIdxStandorteEigenstromTabs', this.state.tabIndex)
                    //     )
                    // }
                    onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
                >
                    <TabList>
                        <Tab
                            style={{
                                color: 'white', backgroundColor: 'var(--color-main-section-dateneingabe)'
                            }}
                        >
                            {i18n('Auswahl', 'tab')}
                        </Tab>
                        {this.renderTabList()}
                    </TabList>
                    <TabPanel
                        style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto' }}
                    >
                        {this.renderAuswahl()}
                    </TabPanel>
                    {this.renderTabPanel()}
                </Tabs>
                {this.state.loading && <WSpinner />}
            </div>
        );
    }

    renderAuswahl(): JSX.Element {
        if (!this.state.eigenstromTypen || !this.state.eigenstromAuswahl) {
            return <div>Lade...</div>;
        }
        return (
            <div style={{ maxWidth: 700, marginBottom: 10 }}>
                <div className={style.infoText}>
                    Welche erneuerbaren Energien bzw. welche Eigenstromgeneration wird an diesem Standort genutzt?
                </div>
                {(!this.props.typeFilter || this.props.typeFilter === 'S') &&
                    <div key={`auswahl-eigenstrom-s-titel`}>
                        <div className={style.titleStrom}>
                            Strom
                        </div>
                    </div>
                }
                {(!this.props.typeFilter || this.props.typeFilter === 'S')
                    && this.state.eigenstromTypen.filter((item: any) => item.typ === 'S').map((item: any, index: number) =>
                        <div key={`auswahl-eigenstrom-s-${index}`}>
                            <div className={style.content}>
                                <input
                                    onChange={(evt: any) => this.handleAuswahl(item.tid, evt.target.checked)}
                                    type='checkbox'
                                    checked={
                                        this.state.eigenstromAuswahl.some((aw: any) => aw.anlagen_eigenstrom_typ_tid === item.tid)
                                    }
                                />
                                {/* this.renderItemInfo(item) */}{item.name}
                            </div>
                        </div>
                    )
                }
                {(!this.props.typeFilter || this.props.typeFilter === 'W') &&
                    <div key={`auswahl-eigenstrom-w-titel`}>
                        <div className={style.titleWaerme}>
                            Wärme
                        </div>
                    </div>
                }
                {(!this.props.typeFilter || this.props.typeFilter === 'W')
                    && this.state.eigenstromTypen.filter((item: any) => item.typ === 'W').map((item: any, index: number) =>
                        <div key={`auswahl-eigenstrom-w-${index}`}>
                            <div className={style.content}>
                                <input
                                    onChange={(evt: any) => this.handleAuswahl(item.tid, evt.target.checked)}
                                    type='checkbox'
                                    checked={
                                        this.state.eigenstromAuswahl.some((aw: any) => aw.anlagen_eigenstrom_typ_tid === item.tid)
                                    }
                                />
                                {/* this.renderItemInfo(item) */}{item.name}
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }

    renderItemInfo(item: any): JSX.Element {
        const style: React.CSSProperties = {
            color: 'white',
            fontSize: 1,
            fontWeight: 'bold',
            display: 'inline-block',
            padding: 4,
            borderRadius: 4,
            width: 50,
            boxSizing: 'border-box',
            textAlign: 'center'
        };
        let name = '';

        if (item.typ && item.typ === 'W') {
            name = 'Wärme';
            style.backgroundColor = '#aa0000';
        } else if (item.typ && item.typ === 'S') {
            name = 'Strom';
            style.backgroundColor = '#0000aa';
        } else {
            return null;
        }
        return <div style={style}>{name}</div>;
    }

    renderTabList(): JSX.Element[] {
        if (!this.state.eigenstromAuswahl) {
            return null;
        }
        // Eigenwärme überall ausblenden
        return (this.state.eigenstromTypen || []).map((item: any, index: number) => {
            const disabled: boolean = !(this.state.eigenstromAuswahl || [])
                .filter((item: any) => !this.props.typeFilter || item.typ === this.props.typeFilter)
                .some((auswahl: any) => (auswahl.anlagen_eigenstrom_typ_tid || null) === item.tid);
            return (
                <Tab
                    style={{
                        color: 'white', backgroundColor: 'var(--color-main-section-dateneingabe)'
                    }}
                    key={`tab-eigenstrom-${index}`}
                    disabled={disabled}
                >
                    {i18n(item.name, 'tab')}
                </Tab>
            );
        });
    }

    renderTabPanel(): JSX.Element[] {
        if (!this.state.eigenstromAuswahl) {
            return null;
        }
        return (this.state.eigenstromTypen || []).map((item: any, index: number) => {
            let typ: JSX.Element = null;
            switch (item.name || null) {
                case 'Biomasse':
                    typ =
                        <StandorteBiomasse
                            standortSelected={this.props.standortSelected}
                            data={this.props.data}
                        />;
                    break;
                case 'Kraft-Wärme-Kopplung':
                    typ =
                        <StandorteKwk
                            standortSelected={this.props.standortSelected}
                            data={this.props.data}
                        />;
                    break;
                case 'Photovoltaik':
                    typ =
                        <StandortePhotovoltaik
                            standortSelected={this.props.standortSelected}
                            data={this.props.data}
                        />;
                    break;
                case 'Solarthermie':
                    typ =
                        <StandorteSolarthermie
                            standortSelected={this.props.standortSelected}
                            data={this.props.data}
                        />;
                    break;
                case 'Windkraft':
                    typ =
                        <StandorteWindkraft
                            standortSelected={this.props.standortSelected}
                            data={this.props.data}
                        />;
                    break;
                case 'Wärmepumpen':
                    typ =
                        <StandorteWaermepumpen
                            standortSelected={this.props.standortSelected}
                            data={this.props.data}
                        />;
                    break;
            }
            return <TabPanel
                key={`panel-eigenstrom-${index}`}
                style={{ flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto' }}
            >
                <div style={{ width: 1000, marginBottom: 10 }}>
                    {typ}
                </div>
            </TabPanel>
        });
    }
}
